var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 813,
    viewBox: "0 0 600 813",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.820557H570C586.569 0.820557 600 14.2521 600 30.8206V782.821C600 799.39 586.569 812.821 570 812.821H0V0.820557Z",
    fill: "#F4FBFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2015_462",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 600,
    height: 813
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.820557H570C586.569 0.820557 600 14.2521 600 30.8206V782.821C600 799.39 586.569 812.821 570 812.821H0V0.820557Z",
    fill: "#F4FBFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2015_462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.252 184.221C238.239 312.728 -50.5984 187.499 -162.891 108.821C-370.495 290.764 -661.14 837.703 -162.891 705.917C335.359 574.132 567.283 720.942 620.964 810.821C686.149 620.41 752.264 55.713 495.252 184.221Z",
    fill: "#DDF1FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgImg);
export default __webpack_public_path__ + "static/media/bg-img.a34e6992e8c63214e99489102aa33ca0.svg";
export { ForwardRef as ReactComponent };